import React from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ComboTopicType from "../../components/inputs/ComboTopicType";

const DivisionPurposeMQTTSearchBox = ({
                                        searchParam,
                                        setSearchParam = require,
                                        updateList,
                                        setCurrentPage,
                                        propIsReadOnly = false,
                                      }) => {

  const onChangeSelect = (e) => {
    setSearchParam((prev) => {
      return {...prev, searchSe: e.target.value};
    });
  };

  const onChangeInputBoxId = (e) => {
    setSearchParam((prev) => {
      return {...prev, searchMqttId: e.target.value};
    })
  };

  const onChangeInputBoxProps = (e) => {
    setSearchParam((prev) => {
      return {...prev, searchPrpos: e.target.value};
    })
  };

  const onClickSearch = (e) => {
    e.preventDefault();
    updateList();
    setCurrentPage(1);
  };


  return (
      <>
        <Form
            id={"searchForm"}
            className={"search-form"}
            onSubmit={onClickSearch}
        >
          <Row className={"justify-content-center"}>
            <Col md={12}>
              <Row className={"justify-content-start"}>
                <Col md={10}>
                  <Row className={"gy-2"}>
                    {/*<Col md={3} className={""}>*/}
                    <Col xxl={3} xl={4} lg={4} md={6}>
                      <ComboTopicType
                          propOnChange={onChangeSelect}
                          propIsReadOnly={propIsReadOnly}
                          propInfo={searchParam.propInfo}
                          propSe={searchParam.propSe}
                      />
                    </Col>

                    {/*<Col md={3}>*/}
                    <Col xxl={3} xl={4} lg={4} md={6}>
                      <Form.Group as={Row} controlId="mqttId">
                        <Form.Label
                            className={`col-form-label label text-end`}
                            style={{width: "100px"}}
                        >
                          MQTT ID
                        </Form.Label>
                        <Col>
                          <Form.Control
                              type="text"
                              placeholder=""
                              className={"input-search text-white"}
                              onChange={onChangeInputBoxId}
                              disabled={propIsReadOnly}
                              defaultValue={searchParam.propMqttId}
                          />
                        </Col>
                      </Form.Group>
                    </Col>

                    {/*<Col md={3}>*/}
                    <Col xxl={3} xl={4} lg={4} md={6}>
                      <Form.Group as={Row} controlId="props">
                        <Form.Label
                            className={`col-form-label label text-end`}
                            style={{width: "100px"}}
                        >
                          용도
                        </Form.Label>
                        <Col>
                          <Form.Control
                              type="text"
                              placeholder=""
                              className={"input-search text-white"}
                              onChange={onChangeInputBoxProps}
                              disabled={propIsReadOnly}
                              defaultValue={searchParam.propPrpos}
                          />
                        </Col>
                      </Form.Group>
                    </Col>

                    {/*{propIsReadOnly ? '' : (
                        <Col md={3} className={"text-center"}>
                          <Button type={"submit"} className={"search-btn px-5"}>
                            검색
                          </Button>
                        </Col>
                    )}*/}

                  </Row>
                </Col>
                {propIsReadOnly ? '' : (
                    <Col md={2}
                         className={"text-center search-btn-container d-flex align-items-center justify-content-center"}>
                      <Button
                          type="submit"
                          className={"search-btn"}
                          style={{width: "100px"}}
                      >
                        검색
                      </Button>
                    </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Form>
      </>
  );
};

export default DivisionPurposeMQTTSearchBox;
